import Swiper from 'swiper'
import { Navigation, Autoplay, EffectCards } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/effect-cards'

let config

export const initSwiper = () => {
	const sliders = document.querySelectorAll('[data-swiper]')

	if (!sliders.length) return

	sliders.forEach((slider) => {
		const type = slider.getAttribute('data-swiper')

		switch (type) {
			case 'menus':
				config = {
					speed: 400,
					effect: 'cards',
					slidesPerView: 1,
					centeredSlides: true,
					modules: [EffectCards],
					cardsEffect: {
						slideShadows: false,
						perSlideOffset: 4
					},
					responsive: {
						breakpoints: {
							650: {
								cardsEffect: {
									perSlideOffset: 8
								}
							}
						}
					}
				}
			break;
			default:
			break;
		}

		const swiper = new Swiper(slider, {...config })

		if (type === 'menus') {
			const buttons = slider.querySelectorAll('.menus-home__button')

			swiper.on('slideChange', () => {
				slider.setAttribute('data-active-index', swiper.activeIndex)
			})

			buttons.forEach((button) => {
				button.addEventListener('mouseenter', () => {
					swiper.slideTo(button.dataset.index)
					slider.setAttribute('data-active-index', button.dataset.index)
				})
			})
		}
	})
}

export default () => {}
